//Константы из SetupView
export default {
  loading: "Загрузка настроек...",
  buttons: {
    save: "Сохранить",
    create: "Создать",
    copy: "Копировать",
    copyto: "Копировать в ...",
    delete: "Удалить",
    cancel: "Отмена",
    show: "Просмотр",
    add_property: "Добавить",
    add: "Добавить",
    create_columns: "Сформировать колонки",
    show_more: "Показать ещё",
    loading: "Загрузка"
  },
  alpha: {
    clear: "Сбросить фильтр"
  },
  cmp: {
    graph_from: "Граф для %CMP_FROM%",
    graph_to: "Граф для %CMP_TO%"
  },
  confirm: {
    delete: "Пожалуйста, подтвердите удаление представления"
  },
  titles: {
    preview: "Просмотр результата",
    preview_disabled: "Просмотр будет доступен только после сохранения",
    title_total: "Сумма по столбцу"
  },
  messages: {
    copy_view_to: "Текущее предcтавление будет скопировано для актива с следующим URI:",
    copy_view_to_success: "Текущее предcтавление скопировано для актива с URI:",
  },
  labels: {
    no_value: "нет",
    type: "Тип представления"
  },
  placeholders: {
    filter_links: "Начните печатать для фильтрации. ^ — только настроенные связи.",
    filter_compare: "Начните печатать для фильтрации. ^ — только графы, отобранные для сравнения."
  },
  validation: {
    required: "Это поле обязательно для заполнения",
    
    form_has_errors: "Форма заполнена с ошибками",

    columns_required: "Необходимо сформировать колонки",
    min_values: "Минимальное количество значений: {{min}}",
    max_values: "Максимальное количество значений: {{max}}",
    fill_or_remove: "Необходимо заполнить поле или удалить его",

    positive_integer: "Необходимо ввести целое десятичное положительное число",
    non_negative_integer: "Необходимо ввести целое десятичное число или ноль",
    pattern: "Поле заполнено неверно, требуется {{pattern}}",

    endpoint_required: "Необходимо указать эндпойнт запроса",
    query_required: "Необходимо указать запрос SPARQL"
  }
}
